import { AppControllerPreviewExtensionCompProps } from '@wix/thunderbolt-components'
import React, { ComponentType } from 'react'
import style from './style/AppControllerPreviewExtension.scss'

type CompProps = AppControllerPreviewExtensionCompProps & { className: string }

const AppControllerPreviewExtension: ComponentType<CompProps> = (props) => {
	const { id, renderPreviewExtension, iconSrc, name } = props

	const className = renderPreviewExtension ? style.host : style.hide

	return (
		<div id={id} className={[className, props.className].join(' ')}>
			{renderPreviewExtension && (
				<div className={style.inlineContent}>
					<img src={iconSrc} className={style.icon} alt="controller" />
					<span className={style.name}>{name}</span>
				</div>
			)}
		</div>
	)
}

export default AppControllerPreviewExtension
